import { useCallback, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped dependency
import FormattedCurrencyLabel from 'I18n/components/FormattedCurrencyLabel';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
// @ts-expect-error untyped dependency
import formatCurrencyName from 'I18n/utils/formatCurrencyName';
import { Flex } from 'foundations-components/components/Flex';
import { Select } from 'foundations-components/transitional/components/Select/Select';
import { useTieredPriceConfigContext } from '../../../../context/TieredPriceConfigContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TieredPriceCurrencySelect = ({
  effectiveCurrencyCode,
  currencyCodesWithData,
  setEffectiveCurrencyCode
}) => {
  const {
    effectiveCurrencyCode: overrideEffectiveCurrencyCode
  } = useTieredPriceConfigContext();
  const options = useMemo(() => currencyCodesWithData.map(currency => {
    const formattedCurrency = formatCurrencyName(currency);
    return {
      text: formattedCurrency,
      value: currency
    };
  }), [currencyCodesWithData]);
  const onCurrencyChange = useCallback(({
    target: {
      value
    }
  }) => {
    setEffectiveCurrencyCode(value);
  }, [setEffectiveCurrencyCode]);

  // If effectiveCurrencyCode is overridden through the context provider, we don't want to show the currency selector
  if (overrideEffectiveCurrencyCode !== undefined) {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "tiered-price-modal-currency-info",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "customerDataProperties.tieredPricing.modal.currencyInfo_jsx",
        elements: {
          FormattedCurrencyLabel
        },
        options: {
          currencyStyle: 'long',
          currencyCode: effectiveCurrencyCode
        }
      })
    });
    // If the currency codes with data is empty, it means this is a single currency portal so we want to show the default currency info
  } else if (currencyCodesWithData.length === 0) {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "tiered-price-modal-currency-info",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "customerDataProperties.tieredPricing.modal.defaultCurrencyInfo_jsx",
        elements: {
          FormattedCurrencyLabel
        },
        options: {
          currencyStyle: 'long',
          currencyCode: effectiveCurrencyCode
        }
      })
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    gap: "100",
    alignItems: "center",
    "data-test-id": "tiered-price-modal-currency-info",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.tieredPricing.modal.currency"
    }), /*#__PURE__*/_jsx(Select, {
      "data-test-id": "tiered-price-modal-currency-select",
      buttonUse: "transparent",
      menuWidth: 250,
      onChange: onCurrencyChange,
      options: options,
      value: effectiveCurrencyCode,
      paddingBlock: "200"
    })]
  });
};